export const siteConfig = {
  name: '51漫画',
  title: '51漫画 | 51漫画免费下载 | 51漫画网址与网页版 | 全网热门漫画在线看',
  description: '51漫画🎯承接51漫画免费下载、51漫画网址、51漫画网页版等搜索需求，提供流畅的在线看漫画体验。🤩本页是51漫画最新地址入口，免费追更热门漫画不迷路。',
  keywords: '51漫画免费下载,51漫画网址,51漫画网页版,51漫画免费观看,51漫画在线看,51漫画app下载,51漫画官网,51漫画入口,免费51漫画',
  url: 'https://vhgsfj.cn',
};